// @flow
import React from 'react'
import Avatar from '@components/app/avatar'
import Link from 'next/link'
import { UserProps } from '../../../../types/user'

interface Props {
  user: UserProps
}

const UserArea = ({ user }: Props) => (
  <Link
    href={`/user/${user.username}`}
    className="tx-black alt"
  >
    <Avatar className="mr-2" src={user.user_image} width="16" alt={user.name} />
    {user.name}
  </Link>
)

export default UserArea
